import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getCustomerInfo, getIspOwner } from "../../features/qrCodeApi";
import { badge } from "../../components/common/Utils";
import { ToastContainer } from "react-toastify";
import PaymentModal from "../../ownerCustomer/paymentModal";

const QRCodePay = () => {
  const [ispInfo, setIspInfo] = useState(null);
  const [customerInfo, setCustomerInfo] = useState(null);
  const [input, setInput] = useState("");

  const { ispId } = useParams();
  const [isLoading, setIsLoading] = useState(false);

  // modal handle state
  const [show, setShow] = useState(false);

  useEffect(() => {
    getIspOwner(ispId, setIsLoading, setIspInfo);
  }, [ispId]);

  const getCustomerHandler = () => {
    getCustomerInfo(ispInfo.id, setIsLoading, setCustomerInfo, input);
  };

  return (
    <>
      <ToastContainer theme="colored" />

      <div className="ispOwner">
        <div className="container-fluid p-0">
          <div className="container py-3">
            <div className="card border-0 shadow-sm rounded-3 mb-3">
              <div className="card-header bg-gradient-primary text-white border-0">
                <h6 className="fw-bold mb-0">
                  <i className="fas fa-building me-2"></i>
                  {ispInfo?.company}
                </h6>
              </div>

              <div className="card-body displayGrid">
                <div className="info-item displayGrid1">
                  <div className="d-flex align-items-start">
                    <i className="fas fa-user-tie mt-1 me-3 text-primary"></i>
                    <div>
                      <small className="d-block text-muted mb-1">Owner</small>
                      <h6 className="fw-bold mb-0 fs-6">{ispInfo?.name}</h6>
                    </div>
                  </div>

                  <div className="d-flex align-items-start">
                    <i className="fas fa-phone-alt mt-1 me-3 text-primary"></i>
                    <div>
                      <small className="d-block text-muted mb-1">
                        Contact Number
                      </small>
                      <h6 className="fw-bold mb-0 fs-6">
                        {ispInfo?.signature || ispInfo?.mobile}
                      </h6>
                    </div>
                  </div>
                </div>

                <div className="info-item displayGrid1">
                  <div className="d-flex align-items-start">
                    <i className="fas fa-map-marker-alt mt-1 me-3 text-primary"></i>
                    <div>
                      <small className="d-block text-muted mb-1">Office</small>
                      <h6 className="fw-bold mb-0 fs-6">{ispInfo?.address}</h6>
                    </div>
                  </div>

                  <div className="d-flex align-items-start">
                    <i className="fas fa-envelope mt-1 me-3 text-primary"></i>
                    <div>
                      <small className="d-block text-muted mb-1">
                        Email Address
                      </small>
                      <h6 className="fw-bold mb-0 fs-6 text-break">
                        {ispInfo?.email}
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="card border-0 shadow-sm rounded-3">
              <div className="card-header bg-gradient-primary text-white border-0">
                <h6 className="fw-bold mb-0">
                  <i className="fas fa-credit-card text-primary me-2"></i>
                  Bill Payment
                </h6>
              </div>

              <div className="card-body">
                {customerInfo ? (
                  <div className="displayGrid">
                    <div className="d-flex justify-content-between align-items-start">
                      <div>
                        <h6 className="fw-bold mb-1">{customerInfo.name}</h6>
                        <div className="d-flex flex-wrap gap-1 align-items-center">
                          <span className="text-muted fs-6">
                            <i className="fas fa-phone me-1"></i>
                            {customerInfo.mobile}
                          </span>
                        </div>
                      </div>

                      <div className="text-end">
                        <div className="h5 mb-0 fw-bold text-primary">
                          {customerInfo.monthlyFee} TK
                        </div>
                        <small className="text-muted">Monthly</small>
                      </div>
                    </div>

                    <div className="displayGrid1 p-2 bg-light rounded">
                      <div>
                        <small className="d-block text-muted mb-1">
                          Status
                        </small>
                        <div className="d-flex align-items-center">
                          {badge(customerInfo.status)}
                        </div>
                      </div>

                      <div>
                        <small className="d-block text-muted mb-1">
                          Balance
                        </small>
                        <div
                          className={`fw-bold fs-6 ${
                            customerInfo.balance < 0
                              ? "text-danger"
                              : "text-success"
                          }`}
                        >
                          {customerInfo.balance} TK
                          {customerInfo.balance < 0 ? (
                            <i className="fas fa-exclamation-triangle ms-1"></i>
                          ) : (
                            <i className="fas fa-check-circle ms-1"></i>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="p-2 bg-primary bg-opacity-10 rounded border-start border-3 border-primary">
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <h6 className="fw-bold mb-0">Total Payable</h6>
                          <small className="text-muted">One-time payment</small>
                        </div>
                        <div className="text-end">
                          <div className="h4 fw-bold text-success mb-0">
                            {Math.max(
                              customerInfo.monthlyFee,
                              customerInfo.balance < 0
                                ? customerInfo.monthlyFee - customerInfo.balance
                                : customerInfo.monthlyFee
                            )}{" "}
                            TK
                          </div>
                        </div>
                      </div>
                    </div>

                    <button
                      className="btn btn-success rounded-3 shadow-sm btn-lg"
                      data-bs-toggle="modal"
                      data-bs-target="#billPaymentModal"
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                          ></span>
                          Processing...
                        </>
                      ) : (
                        <>
                          <i className="fas fa-credit-card me-2"></i>
                          Pay Now Securely
                        </>
                      )}
                    </button>
                    <button
                      className="btn btn-outline-primary btn-lg"
                      onClick={() => {
                        setCustomerInfo(null);
                        setInput("");
                      }}
                    >
                      <i className="fas fa-redo me-2"></i>
                      Search Another Account
                    </button>
                  </div>
                ) : (
                  <>
                    <div className="mb-3">
                      <small className="text-muted mt-1 d-block">
                        <i className="fas fa-info-circle me-1"></i>
                        Find your ID and pay monthly bills
                      </small>

                      <div className="input-group shadow-sm">
                        <span className="input-group-text bg-white border-end-0">
                          <i className="fas fa-id-card text-primary"></i>
                        </span>
                        <input
                          className="form-control border-start-0"
                          type="text"
                          id="customerInfo"
                          onChange={(e) => setInput(e.target.value)}
                          placeholder="Enter Customer ID"
                          aria-label="Customer Information"
                        />
                      </div>
                    </div>

                    <button
                      onClick={getCustomerHandler}
                      className="btn btn-primary w-100 rounded-3 shadow-sm"
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                          ></span>
                          Searching...
                        </>
                      ) : (
                        <>
                          <i className="fas fa-search me-2"></i>
                          Find & Proceed to Payment
                        </>
                      )}
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>

          <div className="glass-gradient py-3">
            <div className="container">
              <div className="text-center">
                <small className="text-light opacity-75 d-block mb-1">
                  <p>© Shunno IT - {new Date().getFullYear()}</p>
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>

      {customerInfo && <PaymentModal customerData={customerInfo} isPublic />}
    </>
  );
};

export default QRCodePay;
